import type { SxProps, Theme } from '@mui/material'

export const styles = {
  container: {
    width: '100%',
    overflow: 'auto',
  },
  table: {
    minWidth: 650,
  },
  headerCell: {
    fontWeight: 600,
    backgroundColor: (theme: Theme) => theme.palette.background.paper,
  },
  row: {
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  },
  rowHover: {
    '&:hover': {
      backgroundColor: (theme: Theme) => theme.palette.action.hover,
    },
  },
  rowSelected: {
    backgroundColor: (theme: Theme) => theme.palette.action.selected,
    '&:hover': {
      backgroundColor: (theme: Theme) => theme.palette.action.selected,
    },
  },
  pagination: {
    borderTop: (theme: Theme) => `1px solid ${theme.palette.divider}`,
  },
} satisfies Record<string, SxProps<Theme>>
